export const notificacionModel = {
  ti: '',
  no: '',
};
